export enum Language {
  ENGLISH = "en-US",
  FINNISH = "fi",
}

export interface LocaleOptions {
  /**
   * Time format
   *
   * Example values: h:mm A, HH:mm
   */
  timeFormat?: string;

  /**
   * Whether the UI should be right-to-left
   */
  rtl?: boolean;
}

export interface LanguageEntry {
  /**
   * What should appear in the UI as the name for the language
   */
  display: string;

  /**
   * What emoji should be displayed
   */
  emoji: string;

  /**
   * Filename of the related language file
   */
  i18n: string;

  /**
   * Dayjs locale file if different
   */
  dayjs?: string;

  /**
   * Locale options
   */
  localeOptions?: Pick<LocaleOptions, "rtl">;
}

export const Languages: { [key in Language]: LanguageEntry } = {
  "en-US": {
    display: "English (Simplified)",
    emoji: "🇺🇸",
    i18n: "en",
    dayjs: "en",
  },
  fi: {
    display: "suomi",
    emoji: "🇫🇮",
    i18n: "fi",
  },
};

export const TRADITIONAL_DATE_FORMAT = "DD/MM/YYYY";
